import logger from '@core/util/universal-logger';

export default async function useRouteModules(store, routeStoreFactory) {
  if (routeStoreFactory) {
    const { store: routeStore, namespace, plugins } = await routeStoreFactory();

    if (routeStore && namespace) {
      // register the routeStore module
      store.registerModule(namespace, routeStore);
      logger.info('Registered the store submodule with namespace:', namespace);
    }
    if (plugins) {
      // register any plugins
      plugins.forEach((plugin) => plugin(store));
      logger.info('Applied the store plugins:', plugins);
    }
  }
}
